<div class="backpage-wrapper">
  <div class="credential-library-container padding s6 all">
    <app-zentra-admin-stepper></app-zentra-admin-stepper>
  </div>
</div>
